const region = () => ({
    countryCode: null,
    // The /api/region request, shared with the region modal (regionSelector.js) so the page asks once
    response: null,

    // Alpine calls this when the store is registered
    init() {
        this.load().catch((e) => {
            console.error('Failed to fetch region', e)
        })
    },

    load() {
        if (!this.response) {
            // The only parameter the endpoint reads (a country to test with)
            const country = new URLSearchParams(window.location.search).get('CF-IPCountry')
            const params = country ? { 'CF-IPCountry': country } : {}

            this.response = window.api.get('/api/region', params).then(({ data }) => {
                if (data?.geo_country_code) {
                    this.countryCode = data.geo_country_code.toLowerCase()
                }

                return data
            })
        }

        return this.response
    },
})

document.addEventListener('alpine:init', () => {
    window.Alpine.store('region', region())
})

export default region
